import * as React from 'react';
import type { FC, ReactNode } from 'react';

import { StyledTable } from './styles';

export interface DataTableCell {
	readonly key: string;
	readonly content: ReactNode;
	readonly colSpan?: number;
}

export interface DataTableHeader {
	readonly key: string;
	readonly content: ReactNode;
}

export interface DataTableRow {
	readonly key: string;
	readonly cells: ReadonlyArray<DataTableCell>;
}

export interface DataTableProps {
	readonly headers: ReadonlyArray<DataTableHeader>;
	readonly rows: ReadonlyArray<DataTableRow>;
	readonly fallback?: ReactNode;
}

export const DataTable: FC<DataTableProps> = ({ headers, rows, fallback }) => {
	const displayedRows =
		rows.length > 0
			? rows
			: [
					{
						key: 'data-table-fallback',
						cells: [
							{
								key: 'data-table-fallback-cell',
								content: fallback ?? 'No data available.',
								colSpan: Math.max(headers.length, 1)
							}
						]
					}
				];

	return (
		<StyledTable>
			<thead>
				<tr>
					{headers.map(header => (
						<th key={header.key}>{header.content}</th>
					))}
				</tr>
			</thead>
			<tbody>
				{displayedRows.map(row => (
					<tr key={row.key}>
						{row.cells.map(cell => (
							<td key={`${row.key}-${cell.key}`} colSpan={cell.colSpan}>
								{cell.content}
							</td>
						))}
					</tr>
				))}
			</tbody>
		</StyledTable>
	);
};
